import { request } from '@/utils/request'

// get npp=${this.npp}&page=${this.page}&keyword=${this.kw}
export const reqList = (params) => request.get(`delayHail`, { params })

// put
export const reqUpdateState = (payload) =>
  request.put(`delayHail/updatestate`, payload)



// WEBPACK FOOTER //
// ./src/api/recordHailBill/index.js